<!--===========================
=            CHIPS            =
============================-->

<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Chips</div>
      </base-header>
    </v-row>
    <v-row>
    <v-col class="col-12 col-md-6 col-sm-12">
					<base-card >
						<div slot="card-header">#Closable</div>
						<div slot="card-subheader">Closable chips can be controlled with a v-model. You can also listen
							to the click:close event if you want to know when a chip has been closed."</div>
						<div slot="card-body">
							<div class="text-center">
								<v-btn v-if="!chip1 && !chip2 && !chip3 && !chip4"
									   close
									   color="primary"
									   dark
									   @click="chip1 = true, chip2 = true, chip3 = true, chip4= true">
									Reset Chips
								</v-btn>

								<v-chip v-if="chip1"
										class="ma-2"
										close
										@click:close="chip1 = false">
									Closable
								</v-chip>

								<v-chip v-if="chip2"
										class="ma-2"
										close
										color="red"
										text-color="white"
										@click:close="chip2 = false">
									Remove
								</v-chip>

								<v-chip v-if="chip3"
										class="ma-2"
										close
										color="green"
										outlined
										@click:close="chip3 = false">
									Success
								</v-chip>

								<v-chip v-if="chip4"
										class="ma-2"
										close
										color="orange"
										label
										outlined
										@click:close="chip4 = false">
									Complete
								</v-chip>
							</div>
						</div>
					</base-card>
				</v-col>
				<v-col class="col-12 col-md-6 col-sm-12">
					<base-card >
						<div slot="card-header">#Colored</div>
						<div slot="card-subheader">Any color from the Material Design palette can be used to change a
							chips color.</div>
						<div slot="card-body">
							<div class="text-center">
								<v-chip class="ma-2">
									Default
								</v-chip>

								<v-chip class="ma-2"
										color="primary">
									Primary
								</v-chip>

								<v-chip class="ma-2"
										color="secondary">
									Secondary
								</v-chip>

								<v-chip class="ma-2"
										color="red"
										text-color="white">
									Red Chip
								</v-chip>

								<v-chip class="ma-2"
										color="green"
										text-color="white">
									Green Chip
								</v-chip>
							</div>
						</div>
					</base-card>
				</v-col>
			
				<v-col class="col-12 col-md-6 col-sm-12">
					<base-card >
						<div slot="card-header">#Filter</div>
						<div slot="card-subheader">v-chip component has filter option which shows an additional icon to
							you if chip is active. It can be customized using filter-icon.

						</div>
						<div slot="card-body">
							<v-row justify="space-around"
								   align="center">
								<v-chip class="ma-2"
										:input-value="active"
										filter>
									I'm v-chip
								</v-chip>

								<v-chip class="ma-2"
										:input-value="active"
										filter
										filter-icon="mdi-plus">
									I'm v-chip
								</v-chip>

								<v-chip class="ma-2"
										:input-value="active"
										filter
										filter-icon="mdi-minus">
									I'm v-chip
								</v-chip>

								<v-switch v-model="active"
										  label="Active"></v-switch>
							</v-row>
						</div>
					</base-card>
				</v-col>
				<v-col class="col-12 col-md-6 col-sm-12">
					<base-card >
						<div slot="card-header">#Label</div>
						<div slot="card-subheader">Label chips use the v-card border-radius.</div>
						<div slot="card-body">
							<div class="text-center">
								<v-chip class="ma-2"
										label>
									Label
								</v-chip>

								<v-chip class="ma-2"
										color="pink"
										label
										text-color="white">
									<v-icon left>
										mdi-label
									</v-icon>
									Tags
								</v-chip>

								<v-chip class="ma-2"
										color="primary"
										label>
									<v-icon left>
										mdi-account-circle-outline
									</v-icon>
									John Leider
								</v-chip>

								<v-chip class="ma-2"
										close
										color="cyan"
										label
										text-color="white">
									<v-icon left>
										mdi-twitter
									</v-icon>
									New Tweets
								</v-chip>
							</div>
						</div>
					</base-card>
				</v-col>
				
				<v-col class="col-12 col-md-6 col-sm-12">
					<base-card >
						<div slot="card-header">#Outlined</div>
						<div slot="card-subheader">Outlined chips inherit their border color from the current text
							color.</div>
						<div slot="card-body">
							<div class="text-center">
								<v-chip class="ma-2"
										color="success"
										outlined>
									<v-icon left>
										mdi-server-plus
									</v-icon>
									Server Status
								</v-chip>

								<v-chip class="ma-2"
										color="primary"
										outlined
										pill>
									User Account
									<v-icon right>
										mdi-account-outline
									</v-icon>
								</v-chip>

								<v-chip class="ma-2"
										color="deep-purple accent-4"
										outlined>
									<v-icon left>
										mdi-wrench
									</v-icon>
									Update Settings
								</v-chip>

								<v-chip class="ma-2"
										close
										color="indigo darken-3"
										outlined>
									<v-icon left>
										mdi-fire
									</v-icon>
									New Posts Available
								</v-chip>
							</div>
						</div>
					</base-card>
				</v-col>
				<v-col class="col-12 col-md-6 col-sm-12">
					<base-card >
						<div slot="card-header">#Sizes</div>
						<div slot="card-subheader">v-chip component can have various sizes from x-small to x-large.
						</div>
						<div slot="card-body">
							<div class="text-center">
								<v-chip class="ma-2"
										x-small>
									x-small chip
								</v-chip>

								<v-chip class="ma-2"
										small>
									small chip
								</v-chip>

								<v-chip class="ma-2">
									Default
								</v-chip>

								<v-chip class="ma-2"
										large>
									large chip
								</v-chip>

								<v-chip class="ma-2"
										x-large>
									x-large chip
								</v-chip>
							</div>

						</div>
					</base-card>
				</v-col>
			
     
    </v-row>

  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  export default {
    components: {
      BaseCard,
      BaseHeader
    },		data() {
			return {
				active: false,
				menu: false,
				chips: ['Programming', 'Playing video games', 'Watching movies', 'Sleeping'],
				items1: ['Streaming', 'Eating'],
				items: [{
						image: 'https://cdn-images-1.medium.com/max/1024/1*9C9hLji68wV373tk8okLYA.jpeg',
						title: 'TBI’s 5 Best: SF Mocktails to Finish Dry January Strong',
						category: 'Travel',
						keyword: 'Drinks',

					},
					{
						image: 'https://cdn-images-1.medium.com/max/1024/1*BBNtYUieAqHoXKjiJ2mMjQ.png',
						title: 'PWAs on iOS 12.2 beta: the good, the bad, and the “not sure yet if good”',
						category: 'Technology',
						keyword: 'Phones',
					},
					{
						image: 'https://cdn-images-1.medium.com/max/1024/1*rTEtei1UEmNqbq6evRsExw.jpeg',
						title: 'How to Get Media Mentions for Your Business',
						category: 'Media',
						keyword: 'Social',
					},
					{
						image: 'https://cdn-images-1.medium.com/max/1024/1*FD2nkJewVeQnGf0ommQfrw.jpeg',
						title: 'The Pitfalls Of Outsourcing Self-Awareness To Artificial Intelligence',
						category: 'Technology',
						keyword: 'Military',
					},
					{
						image: 'https://cdn-images-1.medium.com/max/1024/1*eogFpsVgNzXQLCVgFzT_-A.jpeg',
						title: 'Degrees of Freedom and Sudoko',
						category: 'Travel',
						keyword: 'Social',
					},
				],
				search: '',
				items2: [{
						text: 'Nature',
						icon: 'mdi-nature',
					},
					{
						text: 'Nightlife',
						icon: 'mdi-glass-wine',
					},
					{
						text: 'November',
						icon: 'mdi-calendar-range',
					},
					{
						text: 'Portland',
						icon: 'mdi-map-marker',
					},
					{
						text: 'Biking',
						icon: 'mdi-bike',
					},
				],
				loading: false,

				selected: [],
				chip1: true,
				chip2: true,
				chip3: true,
				chip4: true,
			}
		},

		methods: {
			remove(item) {
				this.chips.splice(this.chips.indexOf(item), 1)
				this.chips = [...this.chips]
			},
			next() {
				this.loading = true

				setTimeout(() => {
					this.search = ''
					this.selected = []
					this.loading = false
				}, 2000)
			},
			close() {
				alert('Chip close clicked')
			},
			alarm() {
				alert('Turning on alarm...')
			},
			blinds() {
				alert('Toggling Blinds...')
			},
			lights() {
				alert('Toggling lights...')
			},
		},
		computed: {
			keywords() {
				if (!this.search) return []

				const keywords = []

				for (const search of this.searching) {
					keywords.push(search.keyword)
				}

				return keywords
			},
			searching() {
				if (!this.search) return this.items

				const search = this.search.toLowerCase()

				return this.items.filter(item => {
					const text = item.title.toLowerCase()

					return text.indexOf(search) > -1
				})
			},
			allSelected() {
				return this.selected.length === this.items2.length
			},
			categories() {
				const search = this.search.toLowerCase()

				if (!search) return this.items

				return this.items2.filter(item2 => {
					const text = item2.text.toLowerCase()

					return text.indexOf(search) > -1
				})
			},
			selections() {
				const selections = []

				for (const selection of this.selected) {
					selections.push(selection)
				}

				return selections
			},
		},
		watch: {
			selected() {
				this.search = ''
			},
		},
    
  }
</script>

<!--====  End of CHIPS  ====-->
